import { Group } from '@mantine/core'
import React from 'react'
import { ReactElement } from 'react'

import { Col, Row } from '../../../../../1stlog-ui/src/components/Bootstrap'
import Card from '../../../../../1stlog-ui/src/components/Card'
import ColiCount from '../../Form/Shipment/Overview/ColiCount'
import FreightTerm from '../../Form/Shipment/Overview/FreightTerm'
import TotalVolume from '../../Form/Shipment/Overview/TotalVolume'
import TotalWeight from '../../Form/Shipment/Overview/TotalWeight'
import ValueOfGoods from '../../Form/Shipment/Overview/ValueOfGoods'
import ShipmentServices from '../../Form/Shipment/ShipmentServices'

const Shipment = (): ReactElement => {
  return (
    <Card title={i18n.t('shipment', 'Sendung')}>
      <Row>
        <Col>
          <Group spacing="xl">
            <ColiCount readonly />
            <TotalWeight readonly />
            <TotalVolume readonly />
            <FreightTerm readonly />
            <ValueOfGoods readonly />
          </Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <ShipmentServices readonly />
        </Col>
      </Row>
    </Card>
  )
}

export default Shipment
